import moment from "moment";
import { Matchup, MatchupEntry, PlayerPick } from "../models";

export type SideProgress = {
	/** Players whose games have all finished. */
	played: number;
	/** Players with a game in progress. */
	inProgress: number;
	/** Players yet to start. */
	toPlay: number;
	/** Players counting for the side (11, or 15 on Bench Boost). */
	total: number;
};

export const sideProgress = (players: PlayerPick[]): SideProgress => {
	const active = players.filter((p) => p.active === 1);
	let played = 0;
	let inProgress = 0;
	let toPlay = 0;
	active.forEach((p) => {
		if (p.games.length > 0 && p.games.every((g) => g.finished)) {
			played++;
		} else if (p.games.some((g) => g.started && !g.finished)) {
			inProgress++;
		} else {
			toPlay++;
		}
	});
	return { played, inProgress, toPlay, total: active.length };
};

export type MatchupStatus = "upcoming" | "live" | "done";

export const matchupStatus = (m: Matchup): MatchupStatus => {
	const sides = [m.home, m.away];
	const anyStarted = sides.some((s) => s.gamesInProgress > 0 || s.gamesFinished > 0);
	if (!anyStarted) {
		return "upcoming";
	}
	const allDone = sides.every((s) => s.gamesInProgress === 0 && s.gamesNotStarted === 0);
	return allDone ? "done" : "live";
};

/** Earliest kick-off still to come for either side, or null when nothing is left. */
export const nextKickoff = (m: Matchup): moment.Moment | null => {
	let earliest: moment.Moment | null = null;
	[m.home, m.away].forEach((side: MatchupEntry) => {
		side.players
			.filter((p) => p.active === 1)
			.forEach((p) =>
				p.games
					.filter((g) => !g.started && g.kickoff)
					.forEach((g) => {
						const k = moment(g.kickoff);
						if (earliest == null || k.isBefore(earliest)) {
							earliest = k;
						}
					}),
			);
	});
	return earliest;
};

export const formatKickoff = (kickoff: moment.Moment | null): string => (kickoff ? kickoff.format("ddd HH:mm") : "later");
